import {IconArrowRight} from '@tabler/icons-react';
import {ActionIcon} from 'src/design/atoms/ActionIcon';
import type {ActionIconProps} from 'src/design/atoms/ActionIcon';

/**
 * "View" row action icon — thin `ActionIcon` wrapper with an arrow-right
 * glyph, `color="black"`, `variant="subtle"`, `size="sm"`, defaulting
 * `tooltipText` to "View".
 * @registry Icon-only "view/navigate to detail" action for table rows.
 *
 * Ported from `library-m/components/action-icons/ViewActionIcon`. Prop
 * surface kept identical (all `ActionIcon` props pass through, `tooltipText`
 * defaults to "View" but can still be overridden). One deviation: the
 * original hard-coded `size: 'small'`, which is not a valid Mantine
 * `ActionIcon` size token — ported as `size="sm"` (the atom's own default),
 * matching the visible behavior Mantine actually rendered.
 */
export type ViewActionIconProps = Partial<ActionIconProps>;

export const ViewActionIcon = ({
  color = 'black',
  variant = 'subtle',
  size = 'sm',
  tooltipText = 'View',
  ...props
}: ViewActionIconProps) => (
  <ActionIcon
    color={color}
    variant={variant}
    size={size}
    tooltipText={tooltipText}
    {...props}>
    <IconArrowRight />
  </ActionIcon>
);
